import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=6c37f80c&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=6c37f80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37f80c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c37f80c')) {
      api.createRecord('6c37f80c', component.options)
    } else {
      api.reload('6c37f80c', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=6c37f80c&scoped=true&", function () {
      api.rerender('6c37f80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TkMd5YnoCwR9/JS/comp/DateRange.vue"
export default component.exports